import { ProfileRelationshipEnum } from "../../../graphql/supergraphEnums";

export type ProfileWithParentRelationships = {
  parentRelationships?: Array<{
    parentProfileId?: number | null;
    relationshipType?: string | null;
  }> | null;
};

/**
 * Computes count of child owners per profile id: for each profile, finds the Owner parent and increments that parent's count.
 * Counts only Owner relationships (not controller/payment beneficiary). Used by ProfileTree and ProfileActionOverview
 * for joint "minimum two children" and completion.
 */
export const computeChildOwnerCountByProfileId = (
  profiles: (ProfileWithParentRelationships | null)[] | undefined,
): Map<number, number> => {
  const map = new Map<number, number>();
  const list = profiles ?? [];
  for (const p of list) {
    if (!p?.parentRelationships) continue;
    const ownerParent = p.parentRelationships.find(
      (pr) => pr.relationshipType === ProfileRelationshipEnum.Owner,
    );
    if (ownerParent?.parentProfileId != null) {
      map.set(ownerParent.parentProfileId, (map.get(ownerParent.parentProfileId) ?? 0) + 1);
    }
  }
  return map;
};
